"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextAreaLista = void 0;
var textAreaListaModule = require('./TextAreaLista.module.scss');
var react_1 = __importStar(require("react"));
var Corpo_1 = require("../../Tipografia/Corpo/Corpo");
var Cores_1 = require("../../Cores/Cores");
var react_window_1 = require("react-window");
var react_virtualized_auto_sizer_1 = __importDefault(require("react-virtualized-auto-sizer"));
var Botao_1 = require("../../Botao/Botao");
var Icone_1 = require("../../Icone/Icone");
var TextAreaLista = function (_a) {
    var id = _a.id, classes = _a.classes, titulo = _a.titulo, _b = _a.opcoes, opcoes = _b === void 0 ? [] : _b, style = _a.style, onClickItem = _a.onClickItem, onDeleteBtnClick = _a.onDeleteBtnClick;
    var _c = react_1.default.useState(false), hoveringDeleteBtn = _c[0], setHoveringDeleteBtn = _c[1];
    var handleClick = function (item) {
        onClickItem && onClickItem(item);
    };
    (0, react_1.useEffect)(function () { }, [opcoes]);
    return (react_1.default.createElement("div", { id: id, className: "".concat(textAreaListaModule.textAreaLista, " ").concat(classes) },
        react_1.default.createElement("div", { className: textAreaListaModule.labelArea },
            react_1.default.createElement("label", { htmlFor: id },
                react_1.default.createElement(Corpo_1.Corpo, { tipo: "label1", cor: Cores_1.Cores.TextoPadrao.CinzaMU600, negrito: 700 }, titulo ? titulo : 'Titulo do componente:')),
            onDeleteBtnClick &&
                react_1.default.createElement("div", { onMouseOver: function () { return setHoveringDeleteBtn(true); }, onMouseLeave: function () { return setHoveringDeleteBtn(false); } },
                    react_1.default.createElement(Botao_1.Botao, { estilo: hoveringDeleteBtn ? 'error' : 'outlined', tamanho: "small", tipo: "tipoIconSquare", onClick: function () { return onDeleteBtnClick(); }, style: { padding: '0px' } },
                        react_1.default.createElement(Icone_1.Icone, { nome: "delete", largura: "20px", altura: "20px", cor: hoveringDeleteBtn ? Cores_1.Cores.CoresIdentidadeMU.brancoMu : Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 })))),
        react_1.default.createElement("div", { className: "".concat(textAreaListaModule.textArea), style: style },
            react_1.default.createElement(react_virtualized_auto_sizer_1.default, { className: "".concat(textAreaListaModule.lista), style: {
                    minHeight: "".concat(style === null || style === void 0 ? void 0 : style.minHeight),
                    maxHeight: "".concat(style === null || style === void 0 ? void 0 : style.maxHeight),
                } }, function (_a) {
                var height = _a.height, width = _a.width;
                return (react_1.default.createElement(react_window_1.FixedSizeList, { height: height, itemCount: opcoes.length, itemSize: 35, width: width }, function (_a) {
                    var index = _a.index, style = _a.style;
                    return (react_1.default.createElement("div", { key: index, onClick: function () { return handleClick(opcoes[index]); }, id: id, style: style, className: "".concat(textAreaListaModule.itemLista, " ").concat(opcoes[index].estado ? textAreaListaModule.activated : '') }, opcoes[index].titulo));
                }));
            }))));
};
exports.TextAreaLista = TextAreaLista;
